<template>
  <page-header titolo="Bacheca Cliente" icona="fa-house" sfondo="bkg-dashboard-clienti"></page-header>
  <div class="container">
    

  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';

export default {
    name: "DashboardClientiView",
    components: { PageHeader },
    data: function() {
        return {


        }    
    },
    methods: {
        Msg() {
        this.$store.commit('Messaggio', {parms: [true, ['La griglia è stata caricata con successo!'], 'alert alert-success', 'fa-spinner', true, 3000]});
        },
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");
    }
}
</script>

<style>

</style>